import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=46859369"
import script from "./_id.vue?vue&type=script&lang=js"
export * from "./_id.vue?vue&type=script&lang=js"
import style0 from "./_id.vue?vue&type=style&index=0&id=46859369&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EventOverview: require('/app/nuxt/components/EventDetailPage/EventOverview.vue').default,EventDetailIntroduction: require('/app/nuxt/components/EventDetailPage/EventDetailIntroduction.vue').default,EventDetailMore: require('/app/nuxt/components/EventDetailPage/EventDetailMore.vue').default})
